<template>
  <div class="pc-list">
    <!-- PC端头部 -->
    <header class="pc-header">
      <div class="header-container">
        <div class="logo">
          <img src="/img/study.png" alt="logo" class="logo-img" />
          <span class="logo-title">上岸</span>
        </div>
        <nav class="nav-menu">
          <router-link to="/" class="nav-item">首页</router-link>
          <router-link to="#" class="nav-item active">课程</router-link>
          <a href="#about" class="nav-item">关于我们</a>
        </nav>
        <div class="user-actions">
          <span class="user-name">欢迎您，{{ userName || '请登录' }}</span>
          <button class="btn-mine-outline" @click="goMine">我的</button>
        </div>
      </div>
    </header>

    <!-- Hero 搜索 -->
    <section class="pc-list-hero">
      <div class="hero-inner">
        <div class="hero-left">
          <h1 class="hero-title">课程中心</h1>
          <p class="hero-desc">选择你感兴趣的课程，开始学习之旅</p>
        </div>
        <div class="hero-right">
          <div class="hero-search">
            <span class="hero-search-icon">&#128269;</span>
            <input
              class="hero-search-input"
              v-model="keyword"
              type="text"
              placeholder="搜索课程..."
              @input="onSearchInput"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 内容区域 -->
    <section class="pc-list-body">
      <div class="container">

        <!-- 加载 -->
        <div class="loading-box" v-if="loading">
          <div class="loading-spinner"></div>
          <p>{{ loading }}</p>
        </div>

        <!-- 分类目录 -->
        <div class="block" v-if="categories.length">
          <div class="block-head">
            <a class="block-back" @click="goBack">‹ 返回</a>
            <h2 class="block-title">课程目录</h2>
            <span class="block-badge">{{ categories.length }} 个分类</span>
          </div>
          <div class="category-grid">
            <div
              v-for="(item, index) in categories"
              :key="index"
              class="category-card"
              @click="goToList(item.id)"
            >
              <div class="category-card-icon">
                <img src="../assets/images/icon-item-003.png" alt />
              </div>
              <div class="category-card-body">
                <h3 class="category-card-name">{{ item.name }}</h3>
                <p class="category-card-sub">点击浏览课程</p>
              </div>
              <span class="category-card-arrow">›</span>
            </div>
          </div>
        </div>

        <!-- 视频列表 -->
        <div class="block" v-if="videos.length">
          <div class="block-head">
            <a class="block-back" @click="goBack">‹ 返回</a>
            <h2 class="block-title">视频课程</h2>
            <span class="block-badge">{{ videos.length }} 个视频</span>
          </div>
          <div class="video-table">
            <div class="video-row-header">
              <span class="col-thumb">封面</span>
              <span class="col-name">课程名称</span>
              <span class="col-type">类型</span>
              <span class="col-action">操作</span>
            </div>
            <div
              v-for="(video, index) in pagedVideos"
              :key="index"
              class="video-row"
            >
              <div class="col-thumb">
                <div class="video-thumb-box">
                  <img src="../assets/images/icon-item-002.png" alt />
                  <span class="video-thumb-play">&#9654;</span>
                </div>
              </div>
              <div class="col-name">
                <span class="video-name-text">{{ video.name }}</span>
              </div>
              <div class="col-type">
                <span class="tag">视频课程</span>
              </div>
              <div class="col-action">
                <button class="btn-play" @click="sendVideoIaram(video)">立即播放</button>
              </div>
            </div>
          </div>
          <div class="pagination" v-if="totalPages > 1">
            <button class="page-btn" :disabled="videoPage <= 1" @click="videoPage = 1">首页</button>
            <button class="page-btn" :disabled="videoPage <= 1" @click="videoPage--">上一页</button>
            <span class="page-info">{{ videoPage }} / {{ totalPages }}</span>
            <button class="page-btn" :disabled="videoPage >= totalPages" @click="videoPage++">下一页</button>
            <button class="page-btn" :disabled="videoPage >= totalPages" @click="videoPage = totalPages">末页</button>
            <span class="page-jump">
              跳至 <input class="page-jump-input" :class="{'page-jump-error': jumpError}" v-model.number="jumpPage" type="number" min="1" :max="totalPages" @keyup.enter="goToPage" @input="jumpError=''" /> 页
              <button class="page-btn page-jump-btn" @click="goToPage">GO</button>
              <span v-if="jumpError" class="page-jump-tip">{{ jumpError }}</span>
            </span>
          </div>
        </div>

        <!-- 空状态 -->
        <div class="empty-box" v-if="!loading && !categories.length && !videos.length">
          <img src="../assets/images/empty.png" alt="暂无内容" class="empty-img" />
          <h3 class="empty-title">暂无课程内容</h3>
          <p class="empty-desc">请稍后再来查看</p>
        </div>

      </div>
    </section>

    <!-- 页脚 -->
    <footer class="pc-footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <h3>关于我们</h3>
            <p>致力于为学习者提供优质的在线教育资源，助力每个人实现学习目标。</p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy; 2025 ShangAn. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { get_class, get_videos, set_click_rate } from "@/api/category";
import bus from '../services/bus';

export default {
  name: 'ListPC',
  data() {
    return {
      categories: [],
      videos: [],
      keyword: '',
      loading: '正在加载...',
      searchTimer: null,
      videoPage: 1,
      pageSize: 10,
      jumpPage: 1,
      jumpError: ''
    };
  },
  computed: {
    ...mapState({
      userName: state => state.user && state.user.name
    }),
    pagedVideos() {
      const start = (this.videoPage - 1) * this.pageSize;
      return this.videos.slice(start, start + this.pageSize);
    },
    totalPages() {
      return Math.ceil(this.videos.length / this.pageSize);
    }
  },
  created() {
    this.fetchData();
  },
  watch: {
    '$route.params.id'() {
      this.keyword = '';
      this.fetchData();
    },
    videoPage(val) {
      this.$router.replace({ query: { ...this.$route.query, page: val } });
    }
  },
  methods: {
    async fetchData(resetPage) {
      this.loading = '正在加载...';
      this.videoPage = resetPage ? 1 : (Number(this.$route.query.page) || 1);
      const id = this.$route.params.id;
      const [catRes, videoRes] = await Promise.all([
        get_class(id, this.keyword).catch(() => ({ data: { data: [] } })),
        get_videos(id, this.keyword).catch(() => ({ data: { data: [] } }))
      ]);
      const cats = catRes.data.data;
      const vids = videoRes.data.data;
      this.categories = Array.isArray(cats) ? cats : Object.values(cats || {});
      this.videos = Array.isArray(vids) ? vids : Object.values(vids || {});
      this.loading = '';
    },
    onSearchInput() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.fetchData(true);
      }, 300);
    },
    sendVideoIaram(obj) {
      set_click_rate(obj.id);
      bus.$emit('getParam', obj);
      this.$router.push(`/video/${obj.id}/1?categoryId=${this.$route.params.id}`);
    },
    goToList(categoryId) {
      this.$router.push(`/list/${categoryId}`);
    },
    goMine() {
      this.$router.push(this.userName ? '/mine' : '/login');
    },
    goBack() {
      this.$router.go(-1);
    },
    goToPage() {
      const p = Number(this.jumpPage);
      if (p >= 1 && p <= this.totalPages) {
        this.videoPage = p;
        this.jumpError = '';
      } else {
        this.jumpError = `页码超出`;
      }
    }
  }
};
</script>

<style>
@import "../assets/stytels/home-pc.css";

/* ---- Hero 搜索 ---- */
.pc-list-hero {
  margin-top: 70px;
  background: #fff;
  border-bottom: 1px solid #eef0f5;
  padding: 32px 20px;
}

.hero-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}

.hero-left {
  flex-shrink: 0;
}

.hero-title {
  font-size: 26px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 6px;
}

.hero-desc {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.hero-right {
  flex: 1;
  max-width: 400px;
}

.hero-search {
  display: flex;
  align-items: center;
  background: #f4f6fb;
  border-radius: 8px;
  padding: 10px 16px;
  gap: 10px;
  border: 1px solid #e0e4f0;
  transition: border-color 0.2s;
}

.hero-search:focus-within {
  border-color: #667eea;
  background: #fff;
}

.hero-search-icon {
  font-size: 15px;
  color: #999;
  flex-shrink: 0;
}

.hero-search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #333;
  font-size: 14px;
}

.hero-search-input::placeholder {
  color: #bbb;
}

/* ---- 正文 ---- */
.pc-list-body {
  background: #f4f6fb;
  padding: 32px 0 10px;
  min-height: 68vh;
}

.loading-box {
  text-align: center;
  padding: 80px 0;
}

.loading-box p {
  color: #999;
  font-size: 15px;
}

/* ---- 区块 ---- */
.block {
  margin-bottom: 44px;
}

.block-head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}

.block-back {
  font-size: 13px;
  color: #667eea;
  cursor: pointer;
  text-decoration: none;
  margin-right: 8px;
  transition: color 0.2s;
}

.block-back:hover {
  color: #4b5fd8;
}

.block-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
}

.block-badge {
  font-size: 13px;
  color: #999;
  background: #eef0ff;
  padding: 2px 10px;
  border-radius: 10px;
}

/* ---- 分类卡片 ---- */
.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
}

.category-card {
  background: #fff;
  border-radius: 10px;
  padding: 20px 22px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.25s ease;
  border: 1px solid transparent;
}

.category-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  border-color: #e0e4f0;
}

.category-card-icon {
  width: 46px;
  height: 46px;
  border-radius: 10px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.category-card-icon img {
  width: 55%;
  height: 55%;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.category-card-body {
  flex: 1;
}

.category-card-name {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 4px;
}

.category-card-sub {
  font-size: 12px;
  color: #aaa;
  margin: 0;
}

.category-card-arrow {
  font-size: 18px;
  color: #ccc;
  font-weight: 700;
}

/* ---- 视频列表（表格风格） ---- */
.video-table {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
}

.video-row-header {
  display: flex;
  align-items: center;
  padding: 14px 22px;
  background: #f8f9fc;
  border-bottom: 1px solid #eef0f5;
  font-size: 13px;
  color: #999;
  font-weight: 600;
}

.video-row {
  display: flex;
  align-items: center;
  padding: 14px 22px;
  border-bottom: 1px solid #f4f5f8;
  transition: background 0.15s ease;
}

.video-row:last-child {
  border-bottom: none;
}

.video-row:hover {
  background: #fafbff;
}

.col-thumb {
  width: 90px;
  flex-shrink: 0;
}

.video-thumb-box {
  width: 72px;
  height: 48px;
  border-radius: 6px;
  background: linear-gradient(135deg, #eef0f5, #dfe3ed);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.video-thumb-box img {
  width: 45%;
  height: 45%;
  object-fit: contain;
  opacity: 0.4;
}

.video-thumb-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(102, 126, 234, 0.85);
  color: #fff;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 1px;
}

.col-name {
  flex: 1;
  min-width: 0;
  padding: 0 16px;
}

.video-name-text {
  font-size: 15px;
  font-weight: 500;
  color: #1a1a2e;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.col-type {
  width: 110px;
  flex-shrink: 0;
  text-align: center;
}

.tag {
  display: inline-block;
  font-size: 12px;
  color: #667eea;
  background: #eef0ff;
  padding: 3px 12px;
  border-radius: 8px;
}

.col-action {
  width: 120px;
  flex-shrink: 0;
  text-align: right;
}

.btn-play {
  display: inline-block;
  padding: 7px 22px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.btn-play:hover {
  opacity: 0.88;
}

/* ---- 分页 ---- */
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  padding-top: 16px;
}

.page-btn {
  padding: 6px 16px;
  font-size: 13px;
  color: #667eea;
  background: #fff;
  border: 1px solid #dde0ea;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.page-btn:hover:not(:disabled) {
  background: #667eea;
  color: #fff;
  border-color: #667eea;
}

.page-btn:disabled {
  color: #ccc;
  cursor: not-allowed;
  background: #f5f5f5;
}

.page-info {
  font-size: 14px;
  color: #555;
  min-width: 70px;
  text-align: center;
}

.page-jump {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #888;
  margin-left: 8px;
  position: relative;
}

.page-jump-input {
  width: 52px;
  height: 30px;
  text-align: center;
  border: 1px solid #dde0ea;
  border-radius: 6px;
  font-size: 13px;
  color: #333;
  outline: none;
  background: #fff;
  transition: border-color 0.2s;
  -moz-appearance: textfield;
}

.page-jump-input::-webkit-outer-spin-button,
.page-jump-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.page-jump-input:focus {
  border-color: #667eea;
}

.page-jump-input.page-jump-error {
  border-color: #e53935;
  box-shadow: 0 0 0 2px rgba(229,57,53,0.12);
}

.page-jump-tip {
  position: absolute;
  left: 50%;
  top: calc(100% + 4px);
  transform: translateX(-50%);
  font-size: 12px;
  color: #e53935;
  white-space: nowrap;
  background: #fff;
  padding: 2px 10px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  z-index: 10;
}

.page-jump-btn {
  padding: 6px 10px !important;
}

/* ---- 空状态 ---- */
.empty-box {
  text-align: center;
  padding: 80px 20px;
}

.empty-img {
  width: 120px;
  margin-bottom: 16px;
  opacity: 0.7;
}

.empty-title {
  font-size: 18px;
  font-weight: 600;
  color: #999;
  margin: 0 0 6px;
}

.empty-desc {
  font-size: 14px;
  color: #bbb;
  margin: 0;
}

/* ---- 响应式：窄屏时视频列表换卡片 ---- */
@media (max-width: 768px) {
  .video-row-header { display: none; }
  .video-row {
    flex-wrap: wrap;
    gap: 10px;
  }
  .col-name { flex: 1 1 100%; padding: 0; }
  .col-type { width: auto; }
  .col-action { width: auto; }
}
</style>
